export default [{
  type: 'beta',
  name: '体验版',
  price: 0,
  permanent: 0,
  export: 120,
  logo: 99,
  cdn_amount: 30,
  log_retain_days: 3,
  report_type: 'base'
}, {
  type: 'base',
  package: 'yearly_basic',
  name: '基础版',
  price: 299,
  permanent: 10,
  export: 120,
  logo: 99,
  cdn_amount: 300,
  log_retain_days: 7,
  report_type: 'base',
  target_intro: '适合个人初步试用'
}, {
  type: 'advanced',
  package: 'yearly_pro',
  name: '专业版',
  price: 1999,
  permanent: 80,
  export: null,
  logo: null,
  cdn_amount: 2000,
  custom_queue: true,
  log_retain_days: 15,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '适合个人或小团队专业使用'
}, {
  type: 'edu',
  package: 'yearly_edu',
  name: '教育特惠版',
  price: 199.9,
  permanent: 50,
  export: 120,
  logo: 99,
  cdn_amount: 2000,
  custom_queue: true,
  log_retain_days: 15,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '仅限成功认证的公立学校老师购买',
  show: false
}, {
  type: 'zizi',
  package: 'yearly_zizi',
  name: '教育专业版',
  price: 999,
  permanent: 80,
  export: 120,
  logo: 99,
  cdn_amount: 2000,
  custom_queue: true,
  log_retain_days: 15,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '',
  show: false
}, {
  type: 'enterprise',
  package: 'yearly_enterprise',
  name: '企业版',
  prefer: true,
  price: 4999,
  permanent: 200,
  export: null,
  logo: null,
  sub_account: 5,
  custom_domain: true,
  cdn_amount: 5000,
  custom_queue: true,
  custom_encryption: true,
  custom_cdnspeedup: true,
  custom_cs: true,
  log_retain_days: null,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '适合中小公司或部门间办公协同'
}, {
  type: 'professional',
  name: '企业增强版',
  package: 'yearly_enterprise_plus',
  price: 16999,
  price_more: true,
  permanent: null,
  export: null,
  logo: null,
  sub_account: 20,
  custom_domain: true,
  cdn_amount: 16000,
  custom_queue: true,
  custom_encryption: true,
  custom_cdnspeedup: true,
  custom_cs: true,
  online_tutor: true,
  log_retain_days: null,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '适合一定规模公司办公协同'
}]



// WEBPACK FOOTER //
// ./src/config/packages.js